<template xmlns="http://www.w3.org/1999/html">

  <div>
    <vue-snotify></vue-snotify>
    <b-row class="animated fadeIn">
      <b-col sm="12" md="12" lg="12" xl="12">
        <b-row class="card-margin">
          <div class="card">
            <div class="card-body card-body-wizard">
              <loading :active.sync="isLoading"
                       :is-full-page="fullPage"
                       color="#00F">
              </loading>


              <ValidationObserver ref="basic_form" v-slot="{ invalid }">
                <b-row>
                  <b-col sm="12">
                    <h5 class="h5-color">
                      <span class="header-icon"><i class="nav-icon icon-direction"></i></span>
                      Your Customer Details
                    </h5>
                  </b-col>
                </b-row>

                <hr>

                <!-- Vehicle registered/not registered -->
                <ValidationProvider
                    vid="is_registered"
                    name="Is this vehicle registered"
                    v-slot="{ errors }"
                    rules="required">
                  <b-row class="term-section">
                    <b-col cols="12" md="3">
                      <label class="label-name">Is this vehicle registered? <span style="color:red">*</span></label>
                    </b-col>

                    <b-col md="5">
                      <p-radio :disabled="ActionData.customer_form" @change="draftProposalData" class="p-default p-curve p-bigger"
                               v-model="VehicleData.is_registered" :value="1"
                               color="primary-o">YES
                      </p-radio>
                      <p-radio :disabled="ActionData.customer_form" @change="draftProposalData" class="p-default p-curve p-bigger"
                               v-model="VehicleData.is_registered" :value="0"
                               color="danger-o">NO
                      </p-radio>
                    </b-col>


                    <b-col md="4">
                      <label class="label-name empty-label"></label>
                      <div class="msg validation-form-msg required-msg agreement-validation-custom"
                           v-if="!errors[0]">
                                                    <span class="msg-paragraph">
                                                        <span style="color:red">*</span>This field is required
                                                    </span>
                      </div>
                      <div v-else
                           class="msg-fail validation-form-msg agreement-validation-custom">
                                                    <span class="msg-paragraph"
                                                          v-for="(error, index) in errors"
                                                          v-bind:key="index">
                                                      {{ error }}
                                                    </span>
                      </div>
                    </b-col>
                  </b-row>
                </ValidationProvider>

                <ValidationProvider
                    vid="vehicle_no_format"
                    name="Format of the registered number"
                    v-slot="{ errors }"
                    rules="required"
                    v-show="VehicleData.is_registered">
                  <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                      <label class="label-name">Format of the registered number <span style="color:red">*</span> </label>
                      <b-form-group>
                        <b-row>
                          <!-- Passport Number -->
                          <b-col md="12" class="">
                            <v-select
                                label="name"
                                @input="setVehicleNoFormat"
                                :options="vehicle_no_format_list"
                                :reduce="data => data.code"
                                :value="VehicleData.vehicle_no_format"
                                :disabled="ActionData.customer_form"
                                placeholder="--PLEASE SELECT--"
                            ></v-select>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                      <label class="label-name empty-label"></label>
                      <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                                              <span class="msg-paragraph"
                                              ><span style="color:red">*</span>This field is required</span
                                              >
                      </div>
                      <div v-else class="msg-fail validation-form-msg">
                            <span
                                class="msg-paragraph"
                                v-for="(error, index) in errors"
                                v-bind:key="index"
                            >
                              {{ error }}
                            </span>
                      </div>
                    </b-col>
                  </b-row>
                </ValidationProvider>

                <ValidationProvider
                    vid="vehicle_number"
                    name="Vehicle number"
                    v-slot="{ errors }"
                    :rules="vehicle_regex"
                    v-show="VehicleData.is_registered">
                  <b-row class="row-bottom">
                    <b-col sm="6" md="6">
                      <label class="label-name">Vehicle number (according to the selected
                        format) <span style="color:red">*</span></label>
                      <b-form-group>
                        <b-row>
                          <!-- Passport Number -->
                          <b-col md="12" class="">
                            <input-mask
                                v-model="VehicleData.vehicle_number"
                                type="text"
                                id="input-large"
                                size="lg"
                                placeholder="Vehicle number"
                                :disabled="ActionData.customer_form"
                                :mask="vehicle_no_format_mask" maskChar=""
                                class="form-control form-control-lg to-uppercase"
                                v-uppercase></input-mask>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </b-col>
                    <b-col sm="2" md="2">
                      <label class="label-name-btn empty-label"></label>
                      <b-form-group>
                        <button class="btn btn-primary"
                                :disabled="ActionData.customer_form || errors[0] || fetch_button_disabled"
                                v-on:click="fillVehicleDataRmv()">{{ fetch_button_name }}
                        </button>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                      <label class="label-name empty-label"></label>
                      <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                      </div>
                      <div v-else class="msg-fail validation-form-msg">
                                  <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                    {{ error }}
                                  </span>
                      </div>
                    </b-col>
                  </b-row>
                </ValidationProvider>

                <ValidationProvider
                    vid="contact_no_mobile"
                    name="Contact number(Mobile)"
                    v-slot="{ errors }"
                    rules="required|digits:10">
                  <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                      <label class="label-name">Contact number(Mobile) <span style="color:red">*</span></label>
                      <b-form-group>
                        <b-row>
                          <!-- Passport Number -->
                          <b-col md="12" class="">
                            <b-form-input
                                v-model="ProposerData.contact_no_mobile"
                                type="number"
                                id="input-large"
                                size="lg"
                                :disabled="ActionData.customer_form"
                                placeholder="Contact number(Mobile)"
                                @change="draftProposalData"
                            ></b-form-input>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                      <label class="label-name empty-label"></label>
                      <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                      </div>
                      <div v-else class="msg-fail validation-form-msg">
                          <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                            {{ error }}
                          </span>
                      </div>
                    </b-col>
                  </b-row>
                </ValidationProvider>

                <ValidationProvider
                    vid="contact_no_land"
                    name="Contact number(Land)"
                    v-slot="{ errors }"
                    rules="digits:10">
                  <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                      <label class="label-name">Contact number(Land)</label>
                      <b-form-group>
                        <b-row>
                          <!-- Passport Number -->
                          <b-col md="12" class="">
                            <b-form-input
                                v-model="ProposerData.contact_no_land"
                                type="number"
                                id="input-large"
                                size="lg"
                                placeholder="Contact number(Land)"
                                @change="draftProposalData"
                            ></b-form-input>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                      <label class="label-name empty-label"></label>
                      <div v-if="errors[0]" class="msg-fail validation-form-msg">
                          <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                            {{ error }}
                          </span>
                      </div>
                    </b-col>
                  </b-row>
                </ValidationProvider>

                <ValidationProvider
                    vid="customer_type"
                    name="Product Type"
                    v-slot="{ errors }"
                    rules="required">
                  <b-row class="row-bottom">
                    <b-col sm="12" md="8">
                      <label class="label-name">Customer Type <span style="color:red">*</span></label>
                      <b-form-group>
                        <!-- policy type single toggle button -->
                        <b-button
                            type="button"
                            v-on:click="set_customer_type(1)"
                            id="conventional"
                            class="btn btn-sq btn-pad btn-outline-primary btn-outline btn-right"
                            v-bind:class="{
                                        selected_val: ProposerData.customer_type == 1
                                    }">
                          <i class="fa fa-user fa-2x"></i><br/><strong>Individual</strong>
                          <input
                              type="radio"
                              name="chk1"
                              v-model="ProposerData.customer_type"
                              id="item4"
                              value="1"
                              class="hidden"
                              autocomplete="off"
                          /></b-button>

                        <b-tooltip target="conventional" placement="bottom" triggers="hover">
                          <strong>Individual</strong>
                        </b-tooltip>

                        <!-- policy type family toggle button -->
                        <b-button
                            type="button"
                            v-on:click="set_customer_type(2)"
                            id="takaful"
                            class="btn btn-sq btn-pad btn-outline-primary btn-outline btn-right"
                            v-bind:class="{selected_val: ProposerData.customer_type == 2}">
                          <i class="fa fa-users fa-2x"></i><br/><strong>Corporate</strong>
                          <input
                              type="radio"
                              name="chk1"
                              v-model="ProposerData.customer_type"
                              id="customer_type"
                              value="2"
                              class="hidden"
                              autocomplete="off"
                          /></b-button>

                        <b-tooltip target="takaful" placement="bottom" triggers="hover"
                        ><strong>Corporate</strong></b-tooltip
                        >
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                      <label class="label-name empty-label"></label>
                      <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                      </div>
                      <div v-else class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                      </div>
                    </b-col>
                  </b-row>
                </ValidationProvider>

                <ValidationProvider
                    vid="title"
                    name="Proposer's Title"
                    v-slot="{ errors }"
                    rules=""
                    v-if="ProposerData.customer_type == 1">
                  <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                      <label class="label-name">Title <span style="color:red">*</span></label>
                      <b-form-group>
                        <b-row>
                          <!-- Title -->
                          <b-col md="12" class="">
                            <v-select
                                label="name"
                                @input="setTitleList"
                                :options="title_list"
                                :reduce="data => data.name"
                                :value="ProposerData.title"
                                placeholder="--PLEASE SELECT--"
                                @change="draftProposalData"
                            ></v-select>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                      <label class="label-name empty-label"></label>
                      <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                      </div>
                      <div v-else class="msg-fail validation-form-msg">
                                  <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                    {{ error }}
                                  </span>
                      </div>
                    </b-col>
                  </b-row>
                </ValidationProvider>

                <ValidationProvider
                    vid="first_name"
                    name="Proposer's First Name"
                    v-slot="{ errors }"
                    rules="required"
                    v-if="ProposerData.customer_type == 1"
                >
                  <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                      <label class="label-name">Proposer's Name(First Name) <span style="color:red">*</span></label>
                      <b-form-group>
                        <b-row>
                          <!-- Passport Number -->
                          <b-col md="12" class="">
                            <b-form-input
                                v-model="ProposerData.first_name"
                                type="text"
                                id="input-large"
                                size="lg"
                                placeholder="First Name"
                                @change="draftProposalData"
                                class="to-uppercase"
                                v-uppercase></b-form-input>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                      <label class="label-name empty-label"></label>
                      <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                      </div>
                      <div v-else class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                      </div>
                    </b-col>
                  </b-row>
                </ValidationProvider>

                <ValidationProvider
                    vid="last_name"
                    name="Proposer's Last Name"
                    v-slot="{ errors }"
                    rules="required"
                    v-if="ProposerData.customer_type == 1"
                >
                  <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                      <label class="label-name">Proposer's Name(Last Name) <span style="color:red">*</span></label>
                      <b-form-group>
                        <b-row>
                          <!-- Passport Number -->
                          <b-col md="12" class="">
                            <b-form-input
                                v-model="ProposerData.last_name"
                                type="text"
                                id="input-large"
                                size="lg"
                                placeholder="Last Name"
                                @change="draftProposalData"
                                class="to-uppercase"
                                v-uppercase></b-form-input>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                      <label class="label-name empty-label"></label>
                      <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                      </div>
                      <div v-else class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                      </div>
                    </b-col>
                  </b-row>
                </ValidationProvider>

                <ValidationProvider
                    vid="company_name"
                    name="Company Name"
                    v-slot="{ errors }"
                    rules="required"
                    v-if="ProposerData.customer_type == 2"
                >
                  <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                      <label class="label-name">Company Name <span style="color:red">*</span></label>
                      <b-form-group>
                        <b-row>
                          <!-- Passport Number -->
                          <b-col md="12" class="">
                            <b-form-input
                                v-model="ProposerData.company_name"
                                type="text"
                                id="input-large"
                                size="lg"
                                placeholder="Company Name"
                                class="to-uppercase"
                                @change="draftProposalData"
                                v-uppercase></b-form-input>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                      <label class="label-name empty-label"></label>
                      <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                      </div>
                      <div v-else class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                      </div>
                    </b-col>
                  </b-row>
                </ValidationProvider>

                <ValidationProvider
                    vid="business_reg_no"
                    name="Business Registration Number"
                    v-slot="{ errors }"
                    rules=""
                    v-if="ProposerData.customer_type == 2"
                >
                  <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                      <label class="label-name">Business Registration Number <span style="color:red">*</span></label>
                      <b-form-group>
                        <b-row>
                          <!-- Passport Number -->
                          <b-col md="12" class="">
                            <b-form-input
                                v-model="ProposerData.business_reg_no"
                                type="text"
                                id="input-large"
                                size="lg"
                                placeholder="Business Registration Number"
                                @change="draftProposalData"
                                class="to-uppercase"
                                v-uppercase></b-form-input>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                      <label class="label-name empty-label"></label>
                      <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                      </div>
                      <div v-else class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                      </div>
                    </b-col>
                  </b-row>
                </ValidationProvider>

                <div class="btn-holder">
                  <div class="btn-tabs">
                    <button class="btn btn-primary btn-info-action" v-on:click="proceedProposal()">Proceed To
                      Proposal
                    </button>
                  </div>
                  <div class="btn-tabs">
                    <button v-if="!ActionData.customer_form && proposal_status != 9"
                            class="btn btn-success btn-info-action"
                            v-on:click="transferCustomerLink()">Send Link To Customer
                    </button>
                  </div>
                </div>

              </ValidationObserver>
            </div>
          </div>
        </b-row>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import {mapState, mapActions} from "vuex";

export default {
  data: () => {
    return {
      vehicle_no_format_mask: '***********',
      isLoading: false,
      fullPage: true,
      vehicle_regex: '',
      fetch_button_disabled: false,
      fetch_button_name: 'Fetch RMV Data'
    };
  },

  computed: {
    ...mapState("proposal", [
      "customer_errors",
      "ProposerData",
      "OwnershipData",
      "OwnershipData",
      "DriverData",
      "vehicle_no_format_list",
      "city_list",
      "title_list",
      "VehicleData",
      "ActionData",
      "proposal_id",
      "proposal_status"

    ]),
    ...mapState("login", [
      "access_token",
    ]),
  },
  props: ["error_tab_customer"],
  methods: {
    ...mapActions("proposal", [
      "setCityList",
      "setTitleList",
      "setVehicleNoFormat",
      "getParameterDataList",
      "fillVehicleData",
      "getProposalData",
      "saveProposalData",
      "sendCustomerLink",
      "setProposalId",
      "draftProposalData",
      "validateSendLink",
      "clearStateData",
      "setProposalSeen"

    ]),
    ...mapActions("login", [
      "getGuestToken"
    ]),
    set_customer_type(value) {
      this.ProposerData.customer_type = value;
      this.draftProposalData();
    },
    async getTitleList() {
      let table = 'param_titles';
      const data = {
        table: table,
        type: 'title_list'
      };
      await this.getParameterDataList(data);
    },
    async getVehicleNoFormatList() {
      let table = 'param_vehicle_no_formats';
      const data = {
        table: table,
        type: 'vehicle_no_format_list'
      };
      await this.getParameterDataList(data);
    },
    transferCustomerLink() {
      this.$confirm("Are you sure want to transfer this proposal?").then(() => {
        this.isLoading = true;
        this.validateSendLink().then((response) => {
          if (response.data.errors) {
            this.$refs.basic_form.setErrors(response.data.errors);
            this.isLoading = false;
          } else {
            const data = {
              proposal_id: this.proposal_id,
              status: 2
            };
            this.saveProposalData(data).then((response) => {
              if (!response.error) {
                const smsData = {
                  proposal_id: response.data.data.id
                };
                this.sendCustomerLink(smsData).then((response) => {
                  if (!response.data.errors) {
                    this.$snotify
                        .success(response.data.message, "", {
                          position: "centerTop",
                        }).on("destroyed", () => {
                      this.$router.push({
                        name: "ProposalList"
                      })
                    });
                  } else {
                    this.$snotify
                        .error(response.data.errors.message, "", {
                          position: "centerTop",
                        });
                  }
                  this.isLoading = false;
                });
              }

            });
          }
        });
      });


    },
    proceedProposal() {
      this.isLoading = true;
      /*Validate minimum requirements for proceed*/
      this.validateSendLink().then((response) => {
        if (response.data.errors) {
          this.$refs.basic_form.setErrors(response.data.errors);
          this.isLoading = false;
        } else {
          if (this.ActionData.customer_form && this.$route.query.id && this.$route.query.uuid) {
            this.isLoading = false;
            this.$router.push({
              name: 'ProposalWizardCustomer', query: {
                id: this.$route.query.id,
                uuid: this.$route.query.uuid
              }
            })
          }

          if (!this.ActionData.customer_form && this.$route.query.id) {
            this.isLoading = false;
            this.$router.push({
              name: 'ProposalWizard', query: {
                id: this.$route.query.id
              }
            })
          }

          if (!this.$route.query.id && !this.$route.query.uuid) {
            const data = {
              status: 1
            };
            this.saveProposalData(data).then((response) => {
              if (!response.error) {
                this.$snotify
                    .success(response.data.message, "", {
                      position: "centerTop",
                    }).on("destroyed", () => {
                  this.$router.push({
                    name: 'ProposalWizard', query: {
                      id: response.data.data.hash_id_value
                    }
                  })
                });
              }
              this.isLoading = false;
            });
          }
        }
      });
    },
    initialSetVehicleNoFormat() {
      switch (this.VehicleData.vehicle_no_format) {
        case 1:
          this.vehicle_no_format_mask = '99 SRI 9999';
          this.vehicle_regex = {required: true, regex: /^\d{2} [A-Z]{3} \d{4}$/};
          break
        case 2:
          this.vehicle_no_format_mask = '999-9999';
          this.vehicle_regex = {required: true, regex: /^\d{3}-\d{4}$/};
          break
        case 3:
          this.vehicle_no_format_mask = 'aa-aa-9999';
          this.vehicle_regex = {required: true, regex: /^[A-Z]{2}-[A-Z]{2}-\d{4}$/};
          break
        case 4:
          this.vehicle_no_format_mask = 'aa-aaa-9999';
          this.vehicle_regex = {required: true, regex: /^[A-Z]{2}-[A-Z]{3}-\d{4}$/};
          break
        default:
          break
      }
    },
    fillVehicleDataRmv() {
      this.isLoading = true;
      this.fillVehicleData().then((response) => {
        if (response.data.error) {
          this.$snotify
              .error(response.data.error.message, "", {
                position: "centerTop",
              });
          this.isLoading = false;
        } else {
          this.$snotify
              .success(response.data.message, "", {
                position: "centerTop",
              });
          this.isLoading = false;
          this.fetch_button_disabled = true;
          this.fetch_button_name = 'RMV Data Fetched';
        }
      });
    },
    parseJwt(token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
          atob(base64)
              .split("")
              .map(function (c) {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
              })
              .join("")
      );

      return jsonPayload;
    },
  },
  watch: {
    error_tab_customer: function () {
      this.$refs.form.setErrors(this.customer_errors);
    },
    'VehicleData.vehicle_no_format': function (val, oldval) {
      this.fetch_button_disabled = false;
      this.fetch_button_name = "Fetch RMV Data";
      switch (this.VehicleData.vehicle_no_format) {
        case 1:
          this.vehicle_no_format_mask = '99 SRI 9999';
          this.vehicle_regex = {required: true, regex: /^\d{2} [A-Z]{3} \d{4}$/};
          break
        case 2:
          this.vehicle_no_format_mask = '999-9999';
          this.vehicle_regex = {required: true, regex: /^\d{3}-\d{4}$/};
          break
        case 3:
          this.vehicle_no_format_mask = 'aa-aa-9999';
          this.vehicle_regex = {required: true, regex: /^[A-Z]{2}-[A-Z]{2}-\d{4}$/};
          break
        case 4:
          this.vehicle_no_format_mask = 'aa-aaa-9999';
          this.vehicle_regex = {required: true, regex: /^[A-Z]{2}-[A-Z]{3}-\d{4}$/};
          break
        default:
          break
      }
      this.draftProposalData();
    },
    'ProposerData.title': function (val, oldval) {
      this.draftProposalData();
    },
    'VehicleData.vehicle_number': function (val, oldval) {
      this.draftProposalData();
      this.fetch_button_disabled = false;
      this.fetch_button_name = 'Fetch RMV Data';
    },

  },
  created() {
    this.initialSetVehicleNoFormat();
  },
  mounted() {
    this.clearStateData();
    if (this.$route.query.uuid) {
      this.isLoading = true;

      /*Logged customer user as customer user*/
      let obj = {};
      obj.uuid = this.$route.query.uuid;
      this.getGuestToken(obj).then((response) => {
        if (!response.error) {
          if (this.access_token === null) {
          } else {
            let perm = [];
            let payload = JSON.parse(this.parseJwt(this.access_token));
            payload.scopes.forEach((value, index) => {
              let obj = {};
              obj.actions = value;
              obj.subject = "all";
              perm.push(obj);
            });
            this.$ability.update(perm);
          }

          if (this.$route.query.id) {

            this.getTitleList();
            this.getVehicleNoFormatList();

            this.isLoading = true;
            const data = {
              proposal_id: this.$route.query.id,
              uuid: this.$route.query.uuid
            };
            /*Set cutomer seen status*/
            const seenData = {
              proposal_id: this.$route.query.id,
              seen: 1
            };
            this.setProposalSeen(seenData);
            this.getProposalData(data).then((response) => {
              if (!response.error) {
                this.initialSetVehicleNoFormat();
              }
              /*Redirect to access denied*/
              if ([1, 6, 7, 8, 9, 10, 11, 12].indexOf(response.data.data.proposal_status) >= 0) {
                this.$router.push({
                  name: 'ProposalListCustomer',
                  query: {uuid: this.$route.query.uuid}
                });
              }
              this.isLoading = false;
            });
          } else {
            this.isLoading = false;
          }
        } else {
          this.isLoading = false;
        }

      });
    } else {
      this.getTitleList();
      this.getVehicleNoFormatList();

      if (this.$route.query.id) {
        /*Set customer unseen status*/
        const seenData = {
          proposal_id: this.$route.query.id,
          seen: 0
        };
        this.setProposalSeen(seenData);

        this.isLoading = true;
        const data = {
          proposal_id: this.$route.query.id,
          uuid: this.$route.query.uuid
        };
        this.getProposalData(data).then((response) => {
          if (!response.error) {
            this.initialSetVehicleNoFormat();

            /*Redirect to access denied*/
            if ([2, 5, 6, 7, 12].indexOf(response.data.data.proposal_status) >= 0) {
              this.$router.push({
                name: 'AccessDenied'
              });
            }

          }
          this.isLoading = false;
        });
      } else {
        this.isLoading = false;
      }
    }

  }

};
</script>

<style scoped>
.to-uppercase {
  text-transform: uppercase;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 0px solid #308ee0 !important;
  border-radius: 0.25rem;
}

div.card {
  border: 0;
  margin-bottom: 30px;
  margin-top: 30px;
  border-radius: 6px;
  color: rgba(0, 0, 0, 0.87);
  background: #fff;
  width: 100%;
}

.div.card .card-body {
  padding: 15px 30px;
}

.card-margin {
  margin-top: 0;
  border: solid 1px #cacad0;
  border-radius: 7px;
  box-shadow: 2px 2px 6px -2px;
}

.top-margin {
  margin-top: 85px;
}

.card-body-wizard {
  margin-bottom: -20px;
}

.welcome-page {
  border: solid 1px blue;
}

.btn-holder {
  margin-top: 5px;
}

.btn-tabs {
  float: right;
  margin-left: 3px;
  margin-top: 10px;
}

input::placeholder {
  font-size: 14px;
}

.msg-secound-line {
  margin-top: 0px;
}

.custom-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.toggle-button {
  margin: 0 20px;
}

/*
     * Toggle button styles
     */
.toggle-button {
  position: relative;
  display: inline-block;
  color: #fff;
}

.toggle-button label {
  display: inline-block;
  text-transform: uppercase;
  cursor: pointer;
  text-align: left;
}

.toggle-button input {
  display: none;
}

.toggle-button__icon {
  cursor: pointer;
  pointer-events: none;
}

.toggle-button__icon:before,
.toggle-button__icon:after {
  content: "";
  position: absolute;
  top: 45%;
  left: 35%;
  transition: 0.2s ease-out;
}

/*
     * Toggle button variables
     */
/*
     * Toggle button styles
     */
.toggle-button--aava label {
  height: 50px;
  line-height: 50px;
  transition: all 0.2s;
  border-radius: 2rem;
}

.toggle-button--aava label:before,
.toggle-button--aava label:after {
  position: absolute;
  right: 1.5rem;
  transition: all 0.2s 0.1s ease-out;
}

.toggle-button--aava label:before {
  content: attr(data-on-text);
}

.toggle-button--aava label:after {
  content: attr(data-off-text);
}

.toggle-button--aava input[type="checkbox"] + label {
  width: 120px;
  background: #ff5335;
}

.toggle-button--aava input[type="checkbox"] + label:before {
  opacity: 0;
  transform: translate(0, 20px);
}

.toggle-button--aava input[type="checkbox"] + label:after {
  opacity: 1;
  transform: translate(0, 0);
}

.toggle-button--aava input[type="checkbox"]:checked ~ label {
  width: 120px;
  background: #61b136;
}

.toggle-button--aava input[type="checkbox"]:checked ~ label:before {
  opacity: 1;
  transform: translate(0, 0);
}

.toggle-button--aava input[type="checkbox"]:checked ~ label:after {
  opacity: 0;
  transform: translate(0, -20px);
}

.toggle-button--aava
input[type="checkbox"]:checked
~ .toggle-button__icon:before {
  transform: translate(-10%, 100%) rotate(45deg);
  width: 16.66667px;
}

.toggle-button--aava
input[type="checkbox"]:checked
~ .toggle-button__icon:after {
  transform: translate(30%) rotate(-45deg);
}

.toggle-button--aava .toggle-button__icon {
  position: absolute;
  left: 0;
  top: 0;
  height: 50px;
  width: 50px;
}

.toggle-button--aava .toggle-button__icon:before,
.toggle-button--aava .toggle-button__icon:after {
  height: 3px;
  border-radius: 3px;
  background: #fff;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
}

.toggle-button--aava .toggle-button__icon:before {
  width: 25px;
  transform: rotate(45deg);
}

.toggle-button--aava .toggle-button__icon:after {
  width: 25px;
  transform: rotate(-45deg);
}

.hide {
  display: none;
}


p {
  color: #717887;
  margin-top: -15px;
  margin-left: 2px;
}

.check {
  opacity: 0.5;
  color: #996;
}

.box {
  margin-bottom: 5px;
}

input[type="radio"],
input[type="checkbox"] {
  box-sizing: border-box;
  padding: 0;
  display: none;
}

img {
  width: 100px;
}

.img-thumbnail {
  border: 1px solid #4b78be !important;
  background-color: #ffffff !important;
}

.btn-pad {
  padding: 0 !important;
}

.btn {
  border: solid 0px #e4e7ea;
  border-radius: 0.3rem !important;
}

.btn-sq {
  width: 160px !important;
  height: 70px !important;
  font-size: 12px;
  color: #4b78be;
  background-color: #ffffff;
  margin-top: 2px;
}

.btn-sqw {
  width: 98px !important;
  height: 105px !important;
  font-size: 12px;
  color: #4b78be;
  background-color: #ffffff;
  margin-top: 2px;
}

.btn-ch {
  width: 55px !important;
  height: 58px !important;
  font-size: 12px;
  color: #4b78be;
  background-color: #ffffff;
}

.label-name {
  font-weight: bold;
  color: #31607b;
  margin-bottom: 15px !important;
}

.label-name-btn {
  color: #31607b;
  margin-bottom: 15px !important;
  min-height: 16px;
}

.label-align {
  text-align: right;
}

hr {
  margin-top: 1px !important;
  margin-bottom: 20px !important;
}

/* start of validation msg css */

.msg {
  border: 1px solid #d8e1eb;
  border-radius: 0.2rem;
  padding: 12px;
  background: #f2f6fa;
  margin-bottom: 18px;
  color: #656d7d;
}

.msg-fail {
  border: 1px solid #ff969b;
  border-radius: 0.2rem;
  padding: 12px;
  background: #ffeef3;
  margin-bottom: 18px;
  color: #ff303a;
}

.msg-success {
  border: 1px solid #6ac879;
  border-radius: 0.2rem;
  padding: 12px;
  background: #eeffed;
  margin-bottom: 18px;
  color: #009b0a;
}

/* end ofvalidation msg css */

.msg-paragraph {
  font-size: 12px;
}

.msg-paragraph-con {
  color: #656d7d;
  font-size: 12px;
  margin-top: -15px;
}

.msg-paragraph-con2 {
  color: #656d7d;
  font-size: 12px;
  margin-top: 15px;
}

.form-text-align {
  text-align: center;
}

.country-header {
  margin-left: 26px;
}

span.individual {
  background: url("~@/assets/icon/user.svg") no-repeat top left;
  background-size: contain;
  cursor: pointer;
  display: inline-block;
  height: 20px;
  width: 100%;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: 9px;
}

span.family {
  background: url("~@/assets/icon/family.svg") no-repeat top left;
  background-size: contain;
  cursor: pointer;
  display: inline-block;
  height: 20px;
  width: 100%;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: 9px;
}

span.group {
  background: url("~@/assets/icon/group.svg") no-repeat top left;
  background-size: contain;
  cursor: pointer;
  display: inline-block;
  height: 20px;
  width: 100%;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: 5px;
}

span.single {
  background: url("~@/assets/icon/plane.svg") no-repeat top left;
  background-size: contain;
  cursor: pointer;
  display: inline-block;
  height: 20px;
  width: 100%;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: 12px;
}

span.multi {
  background: url("~@/assets/icon/planes.svg") no-repeat top left;
  background-size: contain;
  cursor: pointer;
  display: inline-block;
  height: 20px;
  width: 100%;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: 2px;
}

span.world {
  background: url("~@/assets/icon/world.svg") no-repeat top left;
  background-size: contain;
  cursor: pointer;
  display: inline-block;
  height: 30px;
  width: 40px;
  margin-top: 5px;
  margin-bottom: 0px;
  margin-left: 10px;
}

span.fourty-five {
  /*background: url("~@/assets/icon/calendar.svg") no-repeat top left;*/
  background-size: contain;
  cursor: pointer;
  display: inline-block;
  height: 25px;
  width: 60px;
  margin-top: 2px;
  margin-bottom: 0px;
  margin-left: 1px;
}

span.ninety {
  /*background: url("~@/assets/icon/calendar.svg") no-repeat top left;*/
  background-size: contain;
  cursor: pointer;
  display: inline-block;
  height: 25px;
  width: 60px;
  margin-top: 2px;
  margin-bottom: 0px;
  margin-left: 1px;
}

.div-color {
  background-color: #fff;
  border-radius: 5px;
  width: 100%;
  padding: 0px 0px 0px 0px;
}

.div-button {
  display: inline-block;
  color: #444;
  border: 1px solid #4b78be;
  background: #fff;
  cursor: pointer;
  vertical-align: middle;
  width: 100%;
  padding: 15px 5px;
  border-radius: 0.3rem !important;
}

/*.div-button:active {
    color:red;
    box-shadow: 0 0 5px -1px rgba(0,0,0,0.6);
}*/

.world-area-text {
  margin-left: -5px;
  color: #4b78be;
}

.small-text {
  margin-top: -6px;
  color: #4b78be;
}

.small-text-middle {
  margin-right: -30px;
}

.small-text-last {
  margin-right: -30px;
}

.row-bottom {
  margin-bottom: 5px;
}

.row-bottom-tf {
  margin-bottom: 8px;
}

.btn-right {
  margin-right: 10px;
}

.btn-bottom {
  margin-bottom: 10px;
}

.col-width {
  width: 100px;
}

.col-width-d {
  width: 100px;
}

.col-width-m {
  width: 100px;
}

.col-width-y {
  width: 120px;
}

.globle-icon {
  margin-left: 12px;
  color: #4b78be;
  margin-top: 4px;
}

.form-group-bottom {
  margin-bottom: 0rem;
}

.modal-footer {
  display: none !important;
}

.agreement-validation-custom {
  margin-top: -20px !important;
}

@media (max-width: 480px) {
  .agreement-validation-custom {
    margin-top: 10px !important;
  }
}

@media (max-width: 769px) {
  .label-name {
    margin-bottom: 25px;
    margin-top: 5px;
    font-weight: bold;
  }

  .label-name-btn {
    margin-bottom: 25px;
    margin-top: 5px;
    min-height: 16px;
  }

  .label-align {
    text-align: left;
  }

  .btn-right {
    margin-right: 9px;
  }

  .world-area-button {
    width: 100%;
    margin-bottom: 15px;
  }

  .world-area-button {
    width: 100%;
    margin-bottom: 10px;
    margin-right: 0px;
  }

  img {
    width: 98px;
  }

  .btn-sq {
    width: 96px !important;
  }

  .btn-sqw {
    width: 96px !important;
  }

  span.world {
    margin-left: 16px;
  }

  .col-width-d {
    width: 108px;
    margin-right: -22px;
  }

  .col-width-m {
    width: 108px;
    margin-right: -22px;
  }

  .col-width-y {
    width: 108px;
  }

  .card-margin {
    margin-top: 0;
    border: none;
    box-shadow: none;
  }

}
</style>
